































import Vue from 'vue';
import LaborCalendar from '@/parts/labor/LaborCalendar.vue';
import API from '@/api/common';
import * as models from '@/class/models/views/setting/workstyle';
import { ICustomHolidayView } from '@/class/models/typed/custom-holiday';
import { ILaborCalendarEvent } from '@/class/models/typed/labor';
import { CalEvent } from '@/class/models/views/labor';
import { formatYmd, addDays } from '@/class/common/util/date_util';
import { toHolidayEvents, toCalEvents } from '@/class/common/util/labor_calendar';
import * as usermodels from '@/class/models/views/setting/users';
import NOC from '@/class/common/const';

function formatYm(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

function resolveBaseMonth(queryMonth: unknown): { baseMonth: Date; shouldReplace: boolean } {
  if (typeof queryMonth === 'string') {
    const parts = queryMonth.split('-');
    const [y, m] = parts.map(Number);

    if (y && m && m >= 1 && m <= 12) {
      const baseMonth = new Date(y, m - 1, 1);
      const normalized = `${y}-${String(m).padStart(2, '0')}`;

      return {
        baseMonth,
        // yyyy-mm 以外（例: yyyy-mm-dd）は replace
        shouldReplace: parts.length !== 2 || queryMonth !== normalized,
      };
    }
  }

  return {
    baseMonth: new Date(),
    shouldReplace: true,
  };
}

const api = new API();

export default Vue.extend({
  name: 'LaborRegistMonthly',
  data() {
    return {
      baseEvents: [] as CalEvent[],
      customHolidays: [] as ICustomHolidayView[],
      userProfile: {} as any,
      initialViewDate: new Date(),
    };
  },
  computed: {
    combinedEvents(
      this: Vue & {
        baseEvents: CalEvent[];
        customHolidays: ICustomHolidayView[];
      },
    ): CalEvent[] {
      return [...this.baseEvents, ...toHolidayEvents(this.customHolidays)];
    },
  },
  components: {
    LaborCalendar,
  },
  created() {
    const { baseMonth } = resolveBaseMonth(this.$route.query.month);
    this.initialViewDate = baseMonth;
  },
  async mounted() {
    let needLogin = false;

    try {
      this.$emit('pushPath', this.$route.path);
      this.$emit('loading', true);

      const resHoriday = await api.get<models.VCustomHolidayList>('workstyle/customholiday');
      const holidays =
        resHoriday.data && Array.isArray(resHoriday.data.customHolidays) ? resHoriday.data.customHolidays : [];
      this.customHolidays = holidays;

      const resUser = await api.get<usermodels.VEditUserProfile>('users/login_user_data');
      if (!resUser.data || !resUser.data.user) {
        console.error('error user');
        needLogin = true;
      } else {
        this.userProfile = resUser.data.user;
      }
    } catch (e) {
      needLogin = true;
      console.error('errorCatchHoge ' + e);
    } finally {
      this.$emit('loading', false);
    }

    if (needLogin) {
      this.$emit('errorModal', 'エラーが発生しました。');
    }
  },
  beforeDestroy() {
    this.$emit('loading', false);
  },
  methods: {
    onDayClick(date: Date) {
      const selectedDate = formatYmd(date);
      this.$router.push({
        name: 'RegistDaily',
        query: {
          date: selectedDate,
        },
      });
    },
    goToDailyWithNewReport() {
      this.$router.push({
        name: 'RegistDaily',
        query: { new_report: 'true' },
      });
    },

    async onRangeChange({ start, endExclusive, month }) {
      const { shouldReplace } = resolveBaseMonth(this.$route.query.month);
      const formattedMonth = formatYm(month);

      const needReplace = shouldReplace || String(this.$route.query.month) !== formattedMonth;

      if (needReplace) {
        this.$router.replace({
          name: this.$route.name!,
          query: {
            month: formattedMonth,
          },
        });
      }

      const from = formatYmd(start); // "2025-11-30"
      const toExclusive = formatYmd(endExclusive); // "2026-01-04" みたいに排他に

      // GET /labor/daily-reports?from=...&to=...
      const res = await api.get<ILaborCalendarEvent[]>('labor/daily_reports', {
        from,
        toExclusive,
      });
      if (res.result && res.data) {
        this.baseEvents = toCalEvents(res.data);
      } else {
        console.log('fetchLaborEvents error', res);
      }
    },
  },
});
